import { STATUS_STYLE, REQUEST_STATUS, EXEC_STATUS, PRIORITY_STYLE, PRIORITIES } from "../lib/constants";

export function StatusBadge({ status, exec = false, testid }) {
  const label = exec ? (EXEC_STATUS[status] || status) : (REQUEST_STATUS[status] || status);
  const cls = STATUS_STYLE[status] || "bg-[#F4EFEA] text-[#5A493C] border-[#D5C5B5]";
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold border ${cls}`}>
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70" />
      {label}
    </span>
  );
}

export function PriorityBadge({ priority, testid }) {
  const cls = PRIORITY_STYLE[priority] || PRIORITY_STYLE.ordinaria;
  return (
    <span data-testid={testid} className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold border ${cls}`}>
      {PRIORITIES[priority] || priority}
    </span>
  );
}
